import "bootstrap/dist/css/bootstrap.min.css";
import { Nav, Image, Button, Dropdown } from "react-bootstrap";
import Cart_icon from "../../../../assests/images/bag.svg";
import {
    SerchBlock,
    OnscrollHide,
    OnscrollShowScreen,
} from './bottomHeaderRightStyle';
import { MESSAGE } from '../../../../utils/message';
import SearchHeader from './searchHeader';
import { useLocation, useNavigate } from "react-router-dom";
import { Username, WriteaReview } from "../../headerBrandRight/headerBrandRightStyle";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { loginUserAction } from "../../../../redux/slices/auth/login-slice";
import { accountDetailHandler } from "../../../../redux/slices/myAccount/accountDetail-slice";
import { setProfileUpdateStatus } from "../../../../redux/slices/myAccount/profileUpdated-slice";
import { DropMenu, UserBtn } from "../bottomHeaderLeft/bottomHeaderLeftStyle";
import Down_arrow from "../../../../assests/images/down-arrow.webp";
import Gnp_logo from "../../../../assests/images/greatnonprofits-white-heart.webp"
import { socialLoginUserAction } from "../../../../redux/slices/auth/socialLogin-slice";
import { totalCountHandler } from "../../../../redux/slices/donationCamp/totalCount-slice";
import { donateCartHandler } from "../../../../redux/slices/donationCamp/donateCart-slice";

const BottomHeaderRight = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isHovered, setIsHovered] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const dispatch: any = useDispatch()
    const token = typeof localStorage !== "undefined" && localStorage.getItem(MESSAGE.tokenLocal);


    const role: any = typeof localStorage !== "undefined" && localStorage.getItem("role");
    const user_id: string | null = typeof localStorage !== "undefined" && localStorage.getItem("userId");
    const availableModules = useSelector((state: any) => state?.modules?.data?.results);
    const accountDetail = useSelector((state: any) => state?.accountDetail);
    const profileUpdated = useSelector((state: any) => state?.profileUpdated);
    // const totalCampCount: any = useSelector(
    //     (state: any) => state?.totalCampCount
    // );

    const { data: totalCampCount, isLoading, error } = useSelector((state: any) => state.donateCart);


    useEffect(() => {
        dispatch(donateCartHandler());
    }, [dispatch]);

    const handleLogin = () => {
        typeof localStorage !== "undefined" && localStorage.removeItem("donation_id")
        setIsLoggedIn(true);
    };

    // useEffect(() => {
    //     dispatch(totalCountHandler());
    // }, [])

    const handleLogout = () => {
        typeof localStorage !== "undefined" && localStorage.clear();
        dispatch(loginUserAction.loginSliceReset())
        dispatch(socialLoginUserAction.socialLoginSliceReset())
        setIsLoggedIn(false);
        navigate('/signin');
    };

    useEffect(() => {
        if (token) {
            handleLogin();
            setIsLoggedIn(true)
        }
        else {
            setIsLoggedIn(false);
        }
    }, [token, accountDetail])
    useEffect(() => {
        if (user_id) {
            dispatch(accountDetailHandler(user_id));
        }
    }, [user_id]);

    useEffect(() => {
        if (profileUpdated.status == "updated" && user_id) {
            dispatch(accountDetailHandler(user_id));
            dispatch(setProfileUpdateStatus(""))
        }
    }, [profileUpdated.status])

    return (
        <Nav>
            <OnscrollHide className="onscroll-hide">
                <Nav.Link href="http://203.109.113.155/GNPBlogs/" target="_blank" className='desktop-blog'>{MESSAGE.blog}</Nav.Link>
                <Nav.Link onClick={() => navigate("/donate-now")} className='bag-img'>
                    <Image src={Cart_icon} />
                    <span className="dcart-items">{totalCampCount?.donation_count || 0}</span>
                </Nav.Link>
                {location.pathname !== "/" && <SerchBlock className="search-show-in-inner-page">
                    <SearchHeader />
                </SerchBlock>}
            </OnscrollHide>
            <OnscrollShowScreen className="serchhd-onscroll">
                <SerchBlock className="search-show-in-inner-page">
                    <SearchHeader />
                </SerchBlock>
                <WriteaReview className='user-write-review desktop-review'>
                    <Button onClick={() => navigate('/write-review')} className="write-yellow-btn">{MESSAGE.createReview}</Button>
                </WriteaReview>
                <UserBtn className="user-btn desktop-view-user">
                    <Dropdown
                        show={isHovered || isLoggedIn} // Show dropdown when hovered or user is logged in
                        onMouseEnter={() => setIsHovered(true)} // Set hover state on mouse enter
                        onMouseLeave={() => setIsHovered(false)} // Reset hover state on mouse leave
                    >
                        <Dropdown.Toggle variant="primary" id="dropdown-basic" className={isLoggedIn ? '' : 'login-btn'} >
                            {isLoggedIn && (
                                <>
                                    <img src={accountDetail?.data?.profile_picture ?? Gnp_logo} alt="login-icon" width="24px" height="24px" className='user-icon' />
                                    <Username>{accountDetail?.data?.screen_name}</Username>
                                    <img src={Down_arrow} alt="down-arrow" width="10px" height="7px" className='down-arrow-icon' />
                                </>
                            )}
                            {!isLoggedIn && (<><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <g id="vuesax_linear_profile-circle" data-name="vuesax/linear/profile-circle" transform="translate(-492 -252)">
                                    <g id="profile-circle">
                                        <path id="Vector" d="M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10Z" transform="translate(494 254)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                        <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(516 276) rotate(180)" fill="none" opacity="0" />
                                        <path id="Vector-3" data-name="Vector" d="M3.4,6.55a.963.963,0,0,0-.24,0,3.28,3.28,0,1,1,.24,0Z" transform="translate(500.72 258.23)" fill="#fff" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                        <path id="Vector-4" data-name="Vector" d="M13.48,3.945a9.934,9.934,0,0,1-6.74,2.62A9.934,9.934,0,0,1,0,3.945a3.679,3.679,0,0,1,1.77-2.58,9.73,9.73,0,0,1,9.94,0A3.679,3.679,0,0,1,13.48,3.945Z" transform="translate(497.26 267.435)" fill="#fff" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                    </g>
                                </g>
                            </svg>{MESSAGE.login}</>)}

                        </Dropdown.Toggle>
                        <DropMenu>
                            <Dropdown.Menu>
                                {isLoggedIn ? (
                                    <>
                                        {<Dropdown.Item onClick={() => navigate("/dashboard")}>{MESSAGE.manageMyNonprofit}</Dropdown.Item>}
                                        <Dropdown.Item onClick={() => navigate("/users/account")}>{MESSAGE.manageMyAccount}</Dropdown.Item>
                                        {/* <Dropdown.Item>{MESSAGE.adminPanel}</Dropdown.Item> */}
                                        <Dropdown.Item onClick={handleLogout}>{MESSAGE.logout}</Dropdown.Item>
                                    </>
                                ) : (
                                    <>
                                        {availableModules?.login && <Dropdown.Item onClick={() => navigate("/signin")}>{MESSAGE.login}</Dropdown.Item>}
                                        {availableModules?.user_registration && <Dropdown.Item onClick={() => navigate("/signup")}>{MESSAGE.signUp}</Dropdown.Item>}
                                    </>
                                )}
                            </Dropdown.Menu>
                        </DropMenu>
                    </Dropdown>
                </UserBtn>
            </OnscrollShowScreen>
        </Nav>
    );
}
export default BottomHeaderRight;